<template>
  <div
    v-if="IsPC"
    class="video-wrap"
  >
    <video
      class="video"
      loop="loop"
      autoplay
      muted
      playsinline
    >
      <source src="https://jobs.jin10.com/video/pcVideo.mp4" type="video/mp4">
    </video>
  </div>
</template>

<script>
import { IsPC } from '@/utils'

export default {
  data() {
    return {
      IsPC: IsPC()
    }
  }
}
</script>

<style lang="scss" scoped >
.video-wrap {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    z-index: -1;
  .video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
